import { getCollectionActionTypes } from '@/Framework/State/Redux/collectionFactory';

export const keyWord = 'LEAGUE_TABLE_UNDERWRITERS';

export default getCollectionActionTypes(keyWord);
